import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import head from 'lodash.head';
import { isPopoverFeatureEnabled } from '../../constants/shared/CommonConstants';
import NavigationTab from './NavigationTab';
import { generateReactKey } from '../../utils/shared/commonUtils';

const NavigationBar = ({
    divTagClassName,
    ulTagClassName,
    tabs,
    disabledTabIds,
    popoverClassName,
    popoverTabs,
    additionalLinks,
    chosenDistrictUid,
    LinkWrapper,
    navTabsDataTestId,
    onNavigationTabClick,
    selectedTabId,
}) => {
    const selectedTab = selectedTabId || (isEmpty(tabs) ? '' : head(tabs).id);

    const onNavigationTabClickHandler = id => {
        if (!disabledTabIds.includes(id)) {
            onNavigationTabClick(id);
        }
    };

    return (
        <div className={divTagClassName}>
            <ul data-test-id={navTabsDataTestId} className={ulTagClassName}>
                {tabs.map(tab => (
                    <NavigationTab
                        key={generateReactKey(tab.id)}
                        id={tab.id}
                        path={tab.path}
                        title={tab.title}
                        liTagClassName={tab.liTagClassName}
                        onTabClick={onNavigationTabClickHandler}
                        spanText={tab.spanText}
                        isActive={tab.id === selectedTab}
                        isDisabled={disabledTabIds.includes(tab.id)}
                        withPopover={
                            popoverTabs.includes(tab.id) &&
                            isPopoverFeatureEnabled(chosenDistrictUid)
                        }
                        popoverClassName={popoverClassName}
                        popoverTitle={tab.popoverTitle}
                        popoverMessage={tab.popoverMessage}
                        LinkWrapper={LinkWrapper}
                    />
                ))}
            </ul>
            {!isEmpty(additionalLinks) && (
                <div className="navigation-links-container">
                    {additionalLinks.map(navigationLink => navigationLink)}
                </div>
            )}
        </div>
    );
};

NavigationBar.defaultProps = {
    divTagClassName: null,
    ulTagClassName: null,
    selectedTabId: null,
    disabledTabIds: [],
    tabs: [],
    onNavigationTabClick: () => {},
    popoverClassName: null,
    popoverTabs: [],
    additionalLinks: [],
    chosenDistrictUid: '',
    LinkWrapper: () => {},
    navTabsDataTestId: '',
};

NavigationBar.propTypes = {
    divTagClassName: PropTypes.string,
    ulTagClassName: PropTypes.string,
    selectedTabId: PropTypes.string,
    disabledTabIds: PropTypes.array,
    tabs: PropTypes.array,
    onNavigationTabClick: PropTypes.func,
    popoverClassName: PropTypes.string,
    popoverTabs: PropTypes.array,
    additionalLinks: PropTypes.arrayOf(PropTypes.object),
    chosenDistrictUid: PropTypes.string,
    LinkWrapper: PropTypes.func,
    navTabsDataTestId: PropTypes.string,
};

export default NavigationBar;
